import styled from "styled-components";
import theme from "../../../styles/theme";

export const PdfContent = styled.div`
  width: 210mm;
  height: 297mm;
  position: relative;
  font-family: Arial, sans-serif;

  /* Hide the PDF content on the screen */
  @media screen {
    display: none;
  }

  /* Show the PDF content when printing or generating PDF */
  @media print {
    display: block;
  }
`;

export const NoCreditContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: black;
  padding: 30px 0;
  div {
    cursor: pointer;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
    background-color: #231f20;
    color: white;
    border-radius: 5px;
    padding: 0 20px;
    &:hover {
      background-color: #1a1a1a;
    }
  }
  svg {
    color: red;
    margin-bottom: 20px;
  }
`;

export const PdfTitle = styled.p`
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  font-size: 12pt;
  line-height: 1.5;
`;

export const PdfBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const PdfContentContainer = styled.div`
  position: absolute;
  color: black;
  margin-top: 0px;
  left: 20mm;
  right: 20mm;

  h1 {
    text-align: center;
  }

  p {
    font-size: 12pt;
    line-height: 1.5;
  }
`;

export const PdfBottom = styled.div`
  margin-top: 30px;
`;

export const PdfCustomerStatus = styled.div`
  margin-bottom: 10px;
`;

export const PdfBullet = styled.div`
  p {
    font-size: 12pt;
    line-height: 1.5;
  }
`;

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .data-container {
    display: flex;
    border: solid 1px ${theme.colors.brown.capivaraLight};
    flex-direction: column;
    text-align-last: center;
    background-color: #fdf8f0;
    color: ${theme.colors.brown.primary};
    font-family: sans-serif;
    margin-top: 3vh;
    width: fit-content;
    align-self: center;
    border-radius: 15px;
    padding-bottom: 4vh;
    margin-inline: 20vw;
    @media ${theme.devices.tablet} {
      margin-inline: 5vw;
    }
    .status {
      font-size: ${theme.fontSize.md2};
      font-weight: bold;
      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.mm};
      }
    }
    .detail {
      font-size: ${theme.fontSize.md};
      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.mm};
      }
    }
    .response-data-container {
      display: flex;
      flex-direction: column;
      row-gap: 0.5vh;
      margin-top: 3vh;
      margin-bottom: 3vh;
    }
  }
  .result {
    color: ${theme.colors.brown.primary};
    display: flex;
    flex-direction: column;
    margin-top: 3vh;
    align-self: center;
    margin-inline: 2vw;
    text-align: justify;
    .lbl {
      font-family: sans-serif;
      font-size: ${theme.fontSize.md2};
      font-weight: bold;
      text-align-last: center;
      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.mm};
      }
    }
  }
  .btn-container {
    display: flex;
    align-self: center;
  }
`;
export const ProcessList = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  color: black;
  align-items: center;
  margin-top: 3vh;
  .label {
    font-family: sans-serif;
    font-size: ${theme.fontSize.md2};
    font-weight: bold;
    text-align-last: center;
    @media ${theme.devices.tablet} {
      font-size: ${theme.fontSize.mm};
    }
  }
`;

export const ProcessItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  .lbl {
    font-family: sans-serif;
    font-weight: bold;
    margin-top: 1vh;
    margin-bottom: -0.5vh;
  }
  @media ${theme.devices.tablet} {
    width: 80vw;
  }
`;
export const Line = styled.hr`
  border-color: ${theme.colors.brown.capivaraLight};
  width: 100%;
`;
export const ConsultLabel = styled.span<{ qty: number }>`
  font-family: sans-serif;
  font-weight: 700;
  color: white;
  font-size: ${theme.fontSize.mm};
  @media ${theme.devices.tablet} {
    font-size: ${(props) => (props.qty < 100 ? "16px" : "15px")};
  }
`;

export const DivSearching = styled.div`
  margin-top: -5px;
  display: flex;
  color: black;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  div {
    display: flex;
    align-items: center;
    justify-content: start;
  }
  span {
    font-size: 14px !important;
    font-weight: 700;
    color: black;
    font-size: ${theme.fontSize.md2};
  }
`;

export const ContainerData = styled.div`
  /* background-color: #f4f7fa; */
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
`;

export const DivTable = styled.div`
  background-color: #42372b;
  color: black;
  padding: 20px;
  width: 92%;
  border-radius: 3px;
`;

export const DivInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 92%;
  margin-bottom: 10px;
`;

export const CardInfo = styled.div`
  background-color: #a9884d;
  position: relative;
  display: flex;
  justify-content: end;
  align-items: end;
  width: 200px;
  height: 70px;
  padding: 10px;
  border-radius: 3px;

  color: #231f20;

  overflow: hidden;
  border: solid 2px #b09151;

  span {
    z-index: 10;
    position: absolute;
    font-size: 12px;
    top: 5px;
    left: 10px;
  }

  p {
    font-size: 20px;
    margin-bottom: -5px;
    font-weight: 700;
  }
`;

export const CardInfoSaque = styled.div`
  background-color: #a9884d;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: end;
  width: 200px;
  height: 70px;
  padding: 12px;
  border-radius: 3px;

  color: #231f20;

  overflow: hidden;
  border: solid 2px #b09151;

  span {
    z-index: 10;
    position: absolute;
    font-size: 12px;
    top: 5px;
  }
`;

interface LeftHalfProps {
  leftColor: string;
}

export const LeftHalf = styled.div<LeftHalfProps>`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.leftColor};
  clip-path: polygon(0 0, 120% 0, 0 100%);
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  align-self: center;
  row-gap: 2vh;
  margin-top: 2vh;
  margin-bottom: 4vh;
  @media ${theme.devices.tablet} {
    width: 70%;
  }
`;
export const ResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2vh;
  margin-top: 1vh;
  @media ${theme.devices.tablet} {
    text-align: center;
  }
  .label {
    font-family: sans-serif;
    font-weight: 600;
    color: black;
    font-size: ${theme.fontSize.md2};
    margin-bottom: 1vh;
  }
  .info {
    color: black;
    font-size: ${theme.fontSize.mm};
    margin-bottom: 1vh;
  }
`;
export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2vh;
  margin-top: 1vh;
  .label {
    font-family: sans-serif;
    font-weight: 600;
    color: black;
    font-size: ${theme.fontSize.md2};
  }
  .details {
    color: black;
    font-size: ${theme.fontSize.mm};
    margin-bottom: 1vh;
    margin-inline: 3vw;
  }
`;
export const AccountSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 35vw;
  min-width: 35vw;
  width: 100%;
  .label {
    color: white;
    width: 100%;
    font-size: ${theme.fontSize.mm};
    text-align-last: right;
    margin-right: 1vw;
    @media ${theme.devices.tablet} {
      text-align-last: auto;
      margin-left: 5vw;
      width: 70vw;
    }
  }
  @media ${theme.devices.tablet} {
    max-width: 95vw;
    min-width: 95vw;
    column-gap: 0px;
    margin-bottom: 2vh;
  }
`;

export const MobileContainer = styled.div`
  display: none;

  @media ${theme.devices.tablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 2vh;
  }
`;
export const FloatingBtnContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 2vh;
  right: 2vw;
  z-index: 1000;
`;
export const ConsultLabelWarning = styled.a`
  font-family: sans-serif;
  font-weight: 700;
  cursor: pointer;
  color: red;
  font-size: ${theme.fontSize.xsm};
`;

export const SaleContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1vw;
  border: solid 1px ${theme.colors.brown.capivaraLight};
  color: white;
  justify-content: center;
  padding: 10px;
  width: 92%;
  align-self: center;
  margin-bottom: 2vh;
  border-radius: 5px;
  text-align: justify;
`;
